import { Component, inject, signal } from '@angular/core';
import { IackathonGroupComponent } from '../../components/iackathon-group/iackathon-group.component';
import { IackathonSavesService } from '../../services/iackathon-saves.service';
import { tap } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-iackathon-group-list-page',
    imports: [
        IackathonGroupComponent,
        MatIconModule,
        MatProgressSpinner,
        RouterLink,
        TranslateModule
    ],
    templateUrl: './iackathon-group-list-page.component.html',
})
export class IackathonGroupListPageComponent {
    private iackathonSavesService = inject(IackathonSavesService);

    protected readonly isLoading = signal(true);
    protected readonly groupSaves = toSignal(
        this.iackathonSavesService.fetchSaves().pipe(tap(() => this.isLoading.set(false)))
    , {initialValue: []});

}
